// eslint-disable-next-line no-restricted-properties
export const generateId = () => Math.round(Math.random() * Math.pow(10, 16));
